var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-Header"},[_c('the-header-menu',{attrs:{"data":_vm.$store.state.ui.menu}}),_vm._v(" "),_c('the-header-categories',{attrs:{"data":_vm.$store.state.ui['nav-categories']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }